<h1 class="page-title w-50"> قطاع الزراعه و استصلاح الأراضى</h1>
<div class="pb-5">
  <div class="d-flex justify-content-between">
    <div class="share-section mb-4 w-50 pt-5">
      <div class="share-text mb-2">شارك المقال على</div>
      <div class="social-icons d-flex justify-content-end gap-2">
        <a href="#" class="social-icon">
          <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#" class="social-icon">
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="banner-container">
      <img src="../../../assets/AgriBusiness.jpg" alt=" " class="banner-image" />
      <div class="growth-badge">
        <span> الزراعة تساهم بنحو 13٪ من الناتج المحلي الإجمالي في مصر </span>
      </div>
    </div>

    <div class="sector-content">
      <p>قطاع الزراعه و استصلاح الأراضى</p>
      <hr />
      <p> قطاع الزراعه و استصلاح الأراضى:</p>
      <p>
        يعد قطاع الزراعة من القطاعات الرئيسية في الاقتصاد المصري، حيث يعمل به نحو حوالي
        27% موظف في عام 2023 وهي أعلى حصة توظيف من بين القطاعات الاقتصادية.
        وصلت الرقعة الزراعية في 2023 إلى 9.7 مليون فدان، بينما تبلغ المساحة المحصولية
        17.5 مليون فدان حتى 2023.
      </p>

      <p>
        وضعت مصر أولوية خاصة للاكتفاء الذاتي بنسبة 75% من القمح خلال السنوات العشر القادمة،
        كما تعطي الحكومة الأولوية لزراعة 1.5 مليون فدان وهو مشروع ضخم يهدف إلى زيادة
        مساحة الأراضي المزروعة، كما تسعى لحفر أكثر من 1500 بئر جديد بالصحراء الغربية
        لتحويل الصحراء إلى أراضٍ صالحة للزراعة.
      </p>

      <p>
        تنقسم المواسم الزراعية في مصر إلى ثلاثة مواسم: الموسم الشتوي، الموسم الصيفي،
        والموسم النيلي، ويوجد كذلك المحاصيل الدائمة أو السنوية التي يمتد موسم إنتاجها
        إلى عام زراعي كامل مثل قصب السكر ومحاصيل الفاكهة والأخشاب.
      </p>

      <p>
        <strong>الاستزراع السمكي:</strong>
        يعتبر السمك مصدراً غذائياً حيوياً في مصر، حيث يمثل ما يقرب من 25.3% من مصادر
        البروتين التي تستهلكها الأسرة المصرية. وتعد تربية الأحياء المائية المصدر الرئيسي
        لإنتاج السمك في مصر، فقد وصل الإنتاج السمكي لعام 2023 إلى 2 مليون طن محققاً
        اكتفاءً ذاتياً بنسبة 85%.
      </p>

      <p>
        بلغ إنتاج المزارع السمكية حوالي 1.6 مليون طن، بينما يأتي باقي الإنتاج من الصيد
        في البحر الأبيض المتوسط، والبحر الأحمر، ونهر النيل، والبحيرات.
      </p>

      <ul>
        <li>يوفر قطاع المزارع السمكية حوالي 816 ألف فرصة عمل.</li>
        <li>منها 150 ألف فرصة عمل في سلاسل قيمة تربية الأحياء المائية.</li>
        <li>حوالي 666 ألف فرصة عمل داخل المزارع السمكية.</li>
        <li>البلطي هو أكثر أنواع الأسماك المستزرعة في مصر.</li>
        <li>يتم استهلاك معظم إنتاج البلاد من الأسماك محلياً.</li>
        <li>معدل الاستهلاك سمكة واحدة للفرد أسبوعياً.</li>
        <li>تبلغ مساحة الثروة السمكية البحرية في مصر حوالي 11 مليون فدان.</li>
      </ul>

      <p>
        يمثل الاستزراع المائي حالياً حوالي 51% من إجمالي الإنتاج السمكي،
        وينتج القطاع الخاص أكثر من 98% من إنتاج الاستزراع المائي.
      </p>

      <p>
        <strong>الإنتاج الداجني:</strong>
        تعتبر صناعة الدواجن من أهم الصناعات الغذائية في مصر، وقد واجهت تحديات كبيرة
        خاصة بعد أزمة إنفلونزا الطيور في عام 2006، إلا أنها استطاعت التعافي وتحقيق
        الاكتفاء الذاتي والعودة للتصدير بعد رفع حظر استمر 14 عاماً.
      </p>

      <ul>
        <li>إنتاج القطاع التجاري من الدواجن حوالي 1.4 مليار طائر.</li>
        <li>إنتاج القطاع الريفي حوالي 320 مليون دجاجة.</li>
        <li>إنتاج مصر من بيض المائدة حوالي 14 مليار بيضة.</li>
        <li>حجم الاستثمارات في صناعة الدواجن حوالي 100 مليار جنيه.</li>
        <li>عدد العاملين في صناعة الدواجن حوالي 3 ملايين عامل.</li>
        <li>يبلغ عدد المنشآت الداجنة في مصر حوالي 38 ألف منشأة.</li>
      </ul>

      <ul>
        <li>هيئة الاستعلامات المصرية</li>
        <li>الجهاز المركزي للتعبئة العامة والإحصاء</li>
        <li>وزارة الزراعة</li>
        <li>هيئة الثروة السمكية</li>
        <li>منظمة الأغذية والزراعة للأمم المتحدة</li>
        <li>وزارة الزراعة واستصلاح الأراضي</li>
      </ul>
      <a href="https://www.investinegypt.gov.eg/Arabic/Pages/exploreMap.aspx?secId=104">لمزيد من المعلومات اضغط هنا</a>
    </div>
  </div>
</div>